var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsAccessManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 10V2H5.5V4H4.5V3H1.5V9H4.5V8H5.5V10H0.5ZM6.5 10V8H7.5V9H8.5V10H6.5ZM9.5 10V9H10.5V8H11.5V10H9.5ZM6.5 4V2H8.5V3H7.5V4H6.5ZM10.5 4V3H9.5V2H11.5V4H10.5ZM8.5 8L7.8 7.3L8.5875 6.5H3V5.5H8.5875L7.8 4.7L8.5 4L10.5 6L8.5 8Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsAccessManagement);
export default __webpack_public_path__ + "static/media/icons-access-management.18f2b3d7.svg";
export { ForwardRef as ReactComponent };